/**
 * apiHelpers — Utilities for unwrapping the paginated API envelope.
 *
 * All list endpoints return:
 * {
 *   "totalRecords": 1,
 *   "pageNumber": 1,
 *   "pageSize": 20,
 *   "totalPages": 1,
 *   "data": [ { ...record } ]
 * }
 */

// Pull the records array out of the envelope
export const extractItems = (response) => response?.data ?? [];

// Pull pagination metadata out of the envelope
export const extractPagination = (response) => ({
  totalRecords: response?.totalRecords ?? 0,
  pageNumber:   response?.pageNumber   ?? 1,
  pageSize:     response?.pageSize     ?? 20,
  totalPages:   response?.totalPages   ?? 1,
});
